import type { FC, ReactElement } from 'react';

import { useRedirectToLobbyCallbackConnected } from '../../../hooks/useRedirectToLobbyCallbackConnected';
import { getWindowObject } from '../../../utils/window';
import { ButtonVariant } from '../../controls/button/Button';

import { BlockingModalActionButton, BlockingModalContent } from './BlockingModalContent';

export const SessionBalanceErrorConnected: FC = (): ReactElement => {
  const redirectToLobby = useRedirectToLobbyCallbackConnected();
  const windowObject = getWindowObject();

  const action: BlockingModalActionButton[] = [
    {
      tk: 'EXIT',
      type: ButtonVariant.MAIN,
      click: (): void => {
        redirectToLobby();
      },
    },
    {
      tk: 'OK',
      type: ButtonVariant.ACCENT,
      click: (): void => {
        windowObject.location.reload();
      },
    },
  ];

  return <BlockingModalContent messageTk="ERROR_COMMUNICATION" actions={action} />;
};
